import { ReduxAction } from "@core/redux/redux.module";
import {
  GET_RESOURCES_RECEIVE, GET_RESOURCES_REQUEST
} from "@core/redux/action/default/default.action.factory";
import { ResourcesState } from "@core/redux/model/default/resources.state.model";

export const RESOURCES_STATE_NAME = "resources";

export function resourcesReducer (state: ResourcesState, action: ReduxAction<any>): ResourcesState {
  if (!state) {
    state = {
      hu: null,
      en: null
    };
  }

  switch (action.type) {
    case GET_RESOURCES_REQUEST:
    case GET_RESOURCES_RECEIVE:
      return changeState(state, action.payload);
    default:
      return state;
  }

  function changeState(originalState: ResourcesState, changes: Object): ResourcesState {
    return Object.assign({}, originalState, changes);
  }
}
